var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('TrackingNoscript'),_vm._v(" "),_c('homepage-header'),_vm._v(" "),_c('v-main',{staticClass:"mastcontent"},[_c('Nuxt')],1),_vm._v(" "),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }